import { useDispatch } from "react-redux";
import { setQuitConfirmationState } from "../../../features/componentStateSlice.js";
import close_icon from "/content/dam/hlb/my/chatbot/images/close.png";

export default function CloseButton() {
    const dispatch = useDispatch();

    const handleCloseChatConfirmation = () => {
        dispatch(setQuitConfirmationState(true));
    };

    return (
        <button id="close-chat" onClick={ handleCloseChatConfirmation }>
            <img src={ close_icon } alt="close" className="close-icon" />
        </button>
    );
};
